export enum MessageType {
	IceBreakers = 'iceBreakers',
	IceBreakersNba = 'iceBreakersNba',
	QuickReplies = 'quickReplies',
	Question = 'question',
	AIText = 'AIText',
	OrderList = 'orderList',
	MangoStylelist = 'mangoStylist',
	AgentText = 'AgentText',
	AboutAI = 'aboutAI',
	LeaveAgentQueue = 'leaveAgentQueue',
	WarningAgentQueue = 'warningAgentQueue',
	SearchAddress = 'searchAddress',
	ErrorMessage = 'errorMessage',
}

export enum MessageRole {
	Human = 'human',
	Ai = 'ai',
	Agent = 'agent',
}

export enum IceBreakerTriggerPoint {
	Start = 'start',
	End = 'end',
	Nba = 'nba',
	Regenerate = 'regenerate',
}

export type IceBreaker = {
	readonly value: string
	readonly type?: IceBreakerTriggerPoint
}

export type IceBreakersMessage = {
	elements: IceBreaker[]
	type: MessageType.IceBreakers | MessageType.IceBreakersNba
	role: MessageRole.Ai
	showAvatar: false
}

export type QuickRepliesMessageFeedback = 'positive' | 'negative'

export type QuickRepliesMessage = {
	elements: { feedback: QuickRepliesMessageFeedback; optionValue: string }[]
	showAvatar: false
	role: MessageRole.Ai
	type: MessageType.QuickReplies
}

export type ProductMessage = {
	id: string
	color: string
}

export type ReplyOrderListMessage = {
	orders: {
		title: string
		price: string
		date: string
		products: ProductMessage[]
	}[]
	role: MessageRole.Ai
	type: MessageType.OrderList
	showAvatar: false
}

export type QuestionMessage = {
	value: string
	type: MessageType.Question
	role: MessageRole.Human
	showAvatar: true
}

export type AITextMessage = {
	value: string
	type: MessageType.AIText
	role: MessageRole.Ai
	showAvatar: true
	isTimeoutAgentMessage?: boolean
}

export type ErrorResponseMessage = {
	value: string
	type: MessageType.ErrorMessage
	role: MessageRole.Ai
	showAvatar: true
	showRetry: boolean
}

export type AgentTextMessage = {
	type: MessageType.AgentText
	role: MessageRole.Agent
	showAvatar: boolean
	isFirstAgentMessage: boolean
	isLastAgentMessage: boolean
	value?: string
}

export type SearchAddressMessage = {
	elements: { optionValue: string; type?: string }[]
	showAvatar: false
	role: MessageRole.Ai
	type: MessageType.SearchAddress
}

export type LeaveAgentQueue = {
	elements: { title: string }
	type: MessageType.LeaveAgentQueue
	role: MessageRole.Agent
	showAvatar: false
}

export type WarningAgentQueue = {
	elements: { title: string }
	type: MessageType.WarningAgentQueue
	role: MessageRole.Agent
	showAvatar: false
}

export type AgentMessage =
	| AgentTextMessage
	| LeaveAgentQueue
	| WarningAgentQueue

export type AboutAIMessage = {
	value: string
	disclaimers: string[]
	type: MessageType.AboutAI
	role: MessageRole.Ai
	showAvatar: true
}

export type RecommendedProduct = {
	id: string
	colorId: string
	image: string
	url: string
	name: string
}

export type MangoStylelistMessage = {
	recommendations: RecommendedProduct[][] | RecommendedProduct[]
	role: MessageRole.Ai
	showAvatar: false
	type: MessageType.MangoStylelist
}

export type ChatbotMessage =
	| QuestionMessage
	| IceBreakersMessage
	| AITextMessage
	| ReplyOrderListMessage
	| QuickRepliesMessage
	| MangoStylelistMessage
	| AgentMessage
	| AboutAIMessage
	| SearchAddressMessage
	| ErrorResponseMessage
